
import { Entity } from '../base/entity';
import { Entry } from '../ui/entry';

export class KontaktOsoba extends Entity {
public static readonly TABLENAME = 'kontakt_osoba';

  public static readonly ID = 'id';
  public static readonly PARTNER_ID = 'partner_id';
  public static readonly IME = 'ime';
  public static readonly PREZIME = 'prezime';
  public static readonly TELEFON = 'telefon';
  public static readonly EMAIL = 'email';
  public static readonly JBKJS = 'jbkjs';
  public static readonly BROJ_LK = 'broj_lk';
  public static readonly BROJ_DOZVOLE = 'broj_dozvole';

  id: number;
  partnerId: string;
  ime: string;
  prezime: string;
  telefon: string;
  email: string;
  jbkjs: string;
  brojLk: string;
  brojDozvole: string;

  isNew: boolean;

}
